import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  getProviders: () => axios.get(`${API}/providers`).then((r) => r.data),
  getStats: () => axios.get(`${API}/stats`).then((r) => r.data),
  triggerCancellation: (provider_id) =>
    axios.post(`${API}/webhook/cancellation`, { provider_id }).then((r) => r.data),
  lockSlot: (slot_id, user_id) =>
    axios.post(`${API}/slots/${slot_id}/lock`, { user_id }).then((r) => r.data),
  bookSlot: (slot_id, lock_id) =>
    axios.post(`${API}/slots/${slot_id}/book`, { lock_id }).then((r) => r.data),
  reset: () => axios.post(`${API}/reset`).then((r) => r.data),
};

export default api;
